"use client";

import createIcon from './util/createIcon';
export default createIcon('M14,6L10.25,11L13.1,14.8L11.5,16C9.81,13.75 7,10 7,10L1,18H23L14,6Z', 'ImageFilterHdr');